function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "letter",
  transform: "translate(-2.000000, -6.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M25.9706295,7.63330061 C25.995806,7.73448878 26.0046663,7.83813615 25.9978953,7.94041911 C25.997965,7.94726778 25.998,7.95412812 25.998,7.961 L25.998,20.039 C25.998,21.1782073 25.0373465,22 23.874,22 L4.124,22 C2.96065352,22 2,21.1782073 2,20.039 L2,7.961 C2,7.93155534 2.00064176,7.90232273 2.0019122,7.87331088 C2.00195923,7.81510472 2.00707562,7.75672828 2.01738611,7.6988777 C2.15204224,6.69785815 3.05195871,6 4.124,6 L23.874,6 C24.922473,6 25.8063061,6.66751126 25.9706295,7.63330061 Z M4.93182276,8 L14.001,14.3135458 L23.0701772,8 L4.93182276,8 Z M23.998,9.79100072 L14.5723421,16.352712 C14.2289546,16.5917627 13.7730454,16.5917627 13.4296579,16.352712 L4,9.7882161 L4,20.039 C4,19.9983204 4.00196337,20 4.124,20 L23.874,20 C23.9960366,20 23.998,19.9983204 23.998,20.039 L23.998,9.79100072 Z",
  id: "Combined-Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/letter.e5152113.svg";
export { SvgComponent as ReactComponent };